/**
 * Whether a generated answer really carries the value about to be read.
 *
 * WHY THIS EXISTS. Every endpoint of the generated client answers the same
 * shape, `{ error?, value? }`, with both fields optional because the DTO
 * describes them that way. The application tests the error and reads the value:
 *
 *   if (res.error) { showAToast(); } else { patchState({ chats: res.value.chats }); }
 *
 * That test narrows nothing. `error` being absent says nothing about `value`
 * being present, so the read in the else branch is unchecked -- in 27 places
 * across this application. An answer that arrives with neither, a 200 with an
 * empty body or a response cut short, took the else branch and threw inside an
 * NGXS action, where nothing catches it and the screen simply stops.
 *
 * WHAT CHANGES WHERE THIS IS USED. Such an answer now takes the error branch,
 * so the person sees the message that branch already shows instead of a screen
 * that stopped. Every other case behaves exactly as before.
 *
 * A TYPE PREDICATE and not a plain boolean, which is the whole point: a
 * function returning boolean filters at runtime and tells the compiler
 * nothing, which is how the 27 reads got written in the first place.
 */
export const carriesAValue = <T>(answer: { error?: unknown; value?: T }): answer is { error?: undefined; value: T } =>
  !answer.error && answer.value !== undefined;
